// import React, { useState } from 'react';
// import {
//   Box,
//   Typography, 
//   Card,
//   Grid,
//   Divider,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   Container,
//   TableRow,
//   FormControlLabel,
//   Checkbox,
//   Radio
// } from '@mui/material';

// // Mapping between user types and plan features
// const userTypeMappings = {
//   buyer: {
//     label: 'Buyer',
//     features: ['no_of_properties']
//   },
//   tenant: {
//     label: 'Tenant',
//     features: ['no_of_properties']
//   },
//   seller: {
//     label: 'Seller/Builder',
//     features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   },
//   landlord: {
//     label: 'Landlord',
//   features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   },
//    agent: {
//     label: 'Agent',
//     features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   },
//   //  builder: {
//   //   label: 'Builder',
//   //  features: ['buyer_no', 'no_of_properties', 'no_of_liked_data', 'matching_enquiry']
//   // }
// };

// const SubscriptionForm = ({ 
//   selectedUserType, 
//   setSelectedUserType, 
//   selectedPlan, 
//   setSelectedPlan,
//   plans, 
//   handlePaymentSubmit 
// }) => {

//   const paymentRef = React.useRef(null);
  
//   const handleUserTypeChange = (userType) => {
//     setSelectedUserType(userType);
//     setSelectedPlan(null);
//   };

//  const handlePlanSelect = (plan) => {
//   setSelectedPlan(plan);
//   setTimeout(() => {
//     paymentRef.current?.scrollIntoView({ 
//       behavior: 'smooth',
//       block: 'nearest'
//     });
//   }, 100); // Small timeout ensures the DOM is updated
// };

//   // Get relevant plans for the selected user type
//   const getFilteredPlans = () => {
//     if (!selectedUserType) return [];
    
//     // Convert selectedUserType (e.g., "buyer") to the corresponding label (e.g., "Buyer")
//     const userTypeLabel = userTypeMappings[selectedUserType].label;
    
//     return plans
//        .filter(plan => plan.user_type === userTypeLabel && plan.status === true)
//       .map(plan => ({
//         ...plan,
//         displayName: `${plan.plan_name} ${userTypeLabel} Plan`
//       }));
//   };

//   return (
//     <Container
//       sx={{
//         py: 2,
//         flex: 1,
//         display: 'flex',
//         flexDirection: 'column',
//         gap: 2,
//         maxWidth: 'sm'
//       }}
//     >
//       <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', mt: 0 }}>Choose Your Subscription</Typography>
      
//       {/* User Type Selection */}
//       <Card sx={{
//         borderRadius: '12px',
//         boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//         background: 'rgba(255, 255, 255, 0.8)',
//         p: 2
//       }}>
//         <Typography variant="h6" gutterBottom>I am a:</Typography>
//         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//           {Object.keys(userTypeMappings).map((userType) => (
//             <FormControlLabel
//               key={userType}
//               control={
//                 <Checkbox
//                   checked={selectedUserType === userType}
//                   onChange={() => handleUserTypeChange(userType)}
//                   color="primary"
//                   size="small"
//                 />
//               }
//               label={<Typography variant="body2">{userTypeMappings[userType].label}</Typography>}
//               sx={{ margin: 0 }}
//             />
//           ))}
//         </Box>
//       </Card>

//       {/* Plan Selection */}
//       {selectedUserType && (
//         <Card sx={{
//           borderRadius: '12px',
//           boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//           background: 'rgba(255, 255, 255, 0.8)',
//           p: 2
//         }}>
//           <Typography variant="h6" gutterBottom sx={{ textAlign: 'center' }}>
//             Available {userTypeMappings[selectedUserType].label} Plans:
//           </Typography>
//           <Grid 
//             container 
//             spacing={2} 
//             sx={{ 
//               justifyContent: 'center',
//               padding: '0 8px'
//             }}
//           >
//             {getFilteredPlans().map((plan) => (
//               <Grid 
//                 item 
//                 xs={12}
//                 key={plan.plan_id}
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'center'
//                 }}
//               >
//                 <Card 
//                   sx={{ 
//                     p: 2, 
//                     width: '100%',
//                     minWidth: '280px',
//                     maxWidth: '320px',
//                     border: selectedPlan?.plan_id === plan.plan_id ? '2px solid #1976d2' : '1px solid #ddd',
//                     cursor: 'pointer',
//                     transition: 'all 0.3s ease',
//                     boxSizing: 'border-box',
//                     background: 'rgba(255, 255, 255, 0.9)',
//                     '&:hover': {
//                       transform: 'translateY(-2px)',
//                       boxShadow: '0 6px 24px rgba(0,0,0,0.15)'
//                     }
//                   }}
//                   onClick={() => handlePlanSelect(plan)}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                     <Radio 
//                       checked={selectedPlan?.plan_id === plan.plan_id}
//                       color="primary"
//                       size="small"
//                     />
//                     <Typography variant="subtitle1">{plan.displayName}</Typography>
//                   </Box>
//                  <Typography 
//   variant="h6" 
//   color="primary" 
//   gutterBottom
//   sx={{ textAlign: 'center' }}
// >
//   {plan.actual_price && plan.actual_price !== plan.charges ? (
//     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
//       <Typography 
//         component="span" 
//         sx={{ 
//           textDecoration: 'line-through',
//           color: 'text.secondary',
//           fontSize: '0.9rem'
//         }}
//       >
//         ₹{plan.actual_price}
//       </Typography>
//       <Typography component="span"
//        sx={{ 
//           color: 'primary',
//           fontSize: '1.2rem'
//         }}
//         >
//         ₹{plan.charges}
//       </Typography>
//     </Box>
//   ) : (
//     `₹${plan.charges}`
//   )}
// </Typography>
//                  <ul style={{ 
//   paddingLeft: '20px', 
//   margin: 0,
//   fontSize: '0.9rem',
//   listStyleType: 'none'
// }}>
//   {userTypeMappings[selectedUserType].features.map(feature => {
//     const unlimitedKey = `${feature}_unlimited`;
//     const isUnlimited = plan[unlimitedKey];
//     const value = isUnlimited ? 'unlimited' : plan[feature];
    
//     let displayText = '';
    
//     if (feature === 'no_of_properties') {
//       if (selectedUserType === 'buyer' || selectedUserType === 'tenant') {
//         displayText = isUnlimited 
//           ? 'You can access unlimited owner details'
//           : `You can access owner details- ${value}`;
//       } else {
//         displayText = isUnlimited 
//           ? 'You can add unlimited properties'
//           : `You can add properties- ${value} `;
//       }
//     } else if (feature === 'no_of_liked_data') {
//       displayText = isUnlimited 
//         ? 'You can access unlimited wishlist details'
//         : `You can access wishlist details- ${value} `;
//     } else if (feature === 'matching_enquiry') {
//       displayText = isUnlimited 
//         ? 'You can access unlimited Buyer details'
//         : `You can access Buyer details - ${value} `;
//     }
    
//     return (
//       <li key={feature} style={{ marginBottom: '4px' }}>
//         • {displayText}
//       </li>
//     );
//   })}
//    <li style={{ marginBottom: '4px' }}>• You can boost up your properties</li>
//   <li style={{ marginBottom: '4px' }}>• Daily Wishlist Tracking</li>
// </ul>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Card>
//       )}

//       {/* Payment Section */}
//       {selectedPlan && (
//         <Card 
//         ref={paymentRef}
//         sx={{
//           borderRadius: '12px',
//           boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//           background: 'rgba(255, 255, 255, 0.8)',
//           p: 2
//         }}>
//           <Typography variant="h5" gutterBottom sx={{ fontSize: '1.3rem' }}>Payment Details</Typography>
//           <Divider sx={{ mb: 2 }} />
          
//           <Box component="form" onSubmit={handlePaymentSubmit}>
//             <Typography variant="h6" gutterBottom>Selected Plan:</Typography>
//             <Table size="small">
//               <TableBody>
//                 <TableRow>
//                   <TableCell sx={{ padding: '6px' }}>Plan Type</TableCell>
//                   <TableCell sx={{ padding: '8px' }}>{selectedPlan.plan_name}</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell sx={{ padding: '8px' }}>User Type</TableCell>
//                   <TableCell sx={{ padding: '8px' }}>{selectedPlan.user_type}</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell sx={{ padding: '8px' }}>Price</TableCell>
//                   <TableCell sx={{ padding: '8px' }}>₹{selectedPlan.charges}</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>

//             <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
//               <Button 
//                 type="submit" 
//                 variant="contained" 
//                 size="medium"
//                 disabled={!selectedPlan}
//                 fullWidth
//                 sx={{
//                   borderRadius: '8px',
//                   py: 1,
//                   fontWeight: 600
//                 }}
//               >
//                 Complete Payment
//               </Button>
//             </Box>
//           </Box>
//         </Card>
//       )}
//     </Container>
//   );
// };

// export default SubscriptionForm;
import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Typography,
  Card,
  Grid,
  Divider,
  Button,
  Table,
  TableBody,
  TableCell,
  Container,
  TableRow,
  FormControlLabel,
  Checkbox as MuiCheckbox,
  Checkbox,
  Radio,
  Tabs,
  Tab,
  Alert
} from '@mui/material';
import Chip from '@mui/material/Chip';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { BASE_URL } from '../../../Api/ApiUrls';
import subformtable from "./../../Dashboard/Images/subformtable.png"
import GuestLoginModal from '../../../../Components/GuestLoginModal';
import { AuthContext } from "./../../../AuthContext/AuthContext";

const userTypeMappings = {
  seller: {
    label: 'Individual Owner/Builder',
    features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
  },
  agent: {
    label: 'Agent',
    features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
  },
  landlord: {
    label: 'Landlord',
    features: ['no_of_properties', 'no_of_liked_data', 'matching_enquiry']
  },
  bankauction: {
    label: 'Bank Auction',
    features: ['no_of_properties']
  }
};

// ✅ Plan order definition
const PLAN_ORDER = ['Free', '1 Months', '3 Months', '6 Months', '12 Months', 'Lifetime'];

const PlanCard = ({ 
  plan, 
  isSelected, 
  onSelect, 
  userType, 
  isAddon = false,
  iosPlans = [],          // ✅ ADD
  selectedPlan = null,    // ✅ ADD
  isIOSApp = false        // ✅ ADD
}) => {
  const mapping = userTypeMappings[userType] || {};
  const isFreePlan = plan.plan_name === 'Free';

const getApplePrice = () => {
  if (!iosPlans || iosPlans.length === 0) return null;

  console.log("iOS Plans:", iosPlans);
  console.log("Current Plan:", plan);

  const match = iosPlans.find(
    p => p.productId === plan.apple_product_id
  );

  console.log("Matched Apple Plan:", match);

  return match?.price ?? null;
};

const applePrice = isIOSApp ? getApplePrice() : null;

const totalAmount = applePrice
  ? parseFloat(String(applePrice).replace(/[^\d.]/g, ''))
  : null;

const basePrice = totalAmount
  ? (totalAmount / 1.18).toFixed(2)
  : null;

const gstAmount = totalAmount
  ? (totalAmount - totalAmount / 1.18).toFixed(2)
  : null;
  

  return (
    <Card 
      sx={{ 
        p: 2,
        width: '100%',
        minWidth: { xs: '260px', sm: '280px' },
        maxWidth: { xs: '300px', sm: '320px' },
        border: isSelected ? '2px solid #1976d2' : '1px solid rgba(0, 0, 0, 0.08)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(247,249,252,0.95) 100%)',
        borderRadius: '12px',
        boxShadow: isSelected ? '0 8px 32px rgba(25, 118, 210, 0.2)' : '0 4px 24px rgba(0,0,0,0.05)',
        '&:hover': {
          transform: { xs: 'none', sm: 'translateY(-4px)' },
          boxShadow: { xs: '0 4px 16px rgba(0,0,0,0.1)', sm: '0 8px 32px rgba(0,0,0,0.15)' }
        },
        position: 'relative',
        overflow: 'hidden',
        '::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: isAddon 
            ? 'linear-gradient(90deg, #ff9800 0%, #ffc46b 100%)' 
            : 'linear-gradient(90deg, #1976d2 0%, #4dabf5 100%)'
        }
      }}
      onClick={onSelect}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Radio 
            checked={isSelected}
            color={isAddon ? 'warning' : 'primary'}
            size="small"
            sx={{ 
              color: isSelected ? (isAddon ? '#ff9800' : '#1976d2') : '#ccc',
              '&.Mui-checked': {
                color: isAddon ? '#ff9800' : '#1976d2'
              }
            }}
          />
          <Typography variant="subtitle1" sx={{ 
            fontWeight: '600',
            color: '#2a3f5f',
            fontSize: { xs: '1rem', sm: '1.05rem' }
          }}>
            {isAddon ? 'Addon: ' : ''}{plan.plan_name || 'Addon Plan'}
          </Typography>
        </Box>
        {plan.isPopular && (
          <Chip 
            label="Popular" 
            size="small" 
            sx={{ 
              backgroundColor: '#ffeb3b',
              color: '#2a3f5f',
              fontWeight: 'bold',
              fontSize: '0.7rem',
              height: '20px'
            }} 
          />
        )}
      </Box>

      {/* ✅ PRICE SECTION */}
      <Box sx={{ textAlign: 'center', mt: 1, mb: 2 }}>
        {isFreePlan ? (
          // ✅ Free plan — just show FREE, no GST
          <>
            <Typography
              sx={{
                color: '#4caf50',
                fontSize: { xs: '1.6rem', sm: '1.7rem' },
                fontWeight: '700'
              }}
            >
              FREE
            </Typography>
            {plan.trial_days && (
              <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', fontSize: '0.72rem' }}>
                {plan.trial_days} days trial
              </Typography>
            )}
          </>
        ) : plan.actual_price && plan.actual_price !== plan.charges ? (
          // ✅ Discounted paid plan
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              <Typography
                component="span"
                sx={{ 
                  color: isAddon ? '#ff9800' : '#1976d2',
                  fontSize: { xs: '1.6rem', sm: '1.7rem' },
                  fontWeight: '700'
                }}
              >
                {basePrice ?? `₹${plan.charges}`}
              </Typography>
              <Typography 
                component="span" 
                sx={{ 
                  textDecoration: 'line-through',
                  color: 'text.secondary',
                  fontSize: { xs: '1.0rem', sm: '0.9rem' }
                }}
              >
                ₹{plan.actual_price}
              </Typography>
              <Chip 
                label={`${Math.round((1 - plan.charges / plan.actual_price) * 100)}% OFF`} 
                size="small" 
                sx={{ 
                  backgroundColor: '#4caf50',
                  color: 'white',
                  fontWeight: 'bold',
                  fontSize: '0.7rem',
                  height: '20px'
                }} 
              /> 
            </Box>
          </>
        ) : (
          // ✅ Single paid plan
          <>
            <Typography
              sx={{ 
                color: isAddon ? '#ff9800' : '#1976d2',
                fontSize: { xs: '1.6rem', sm: '1.7rem' },
                fontWeight: '700'
              }}
            >
              {applePrice ?? `₹${plan.charges}`}
            </Typography>
          </>
        )}
      </Box>

      <Divider sx={{ my: 1, borderColor: 'rgba(0, 0, 0, 0.08)' }} />

      <ul style={{ 
        paddingLeft: '20px', 
        margin: 0,
        fontSize: { xs: '0.85rem', sm: '0.9rem' },
        listStyleType: 'none'
      }}>
        {mapping.features?.map(feature => {
          const unlimitedKey = `${feature}_unlimited`;
          const isUnlimited = plan[unlimitedKey];
          const value = isUnlimited ? 'unlimited' : plan[feature];
          
          let displayText = '';
          
          if (feature === 'no_of_properties') {
            if (userType === 'buyer' || userType === 'tenant') {
              displayText = isUnlimited 
                ? 'Unlimited owner details access'
                : `Access owner details: ${value}`;
            } else {
              displayText = isUnlimited 
                ? 'List an unlimited number of properties'
                : `List properties limit: ${value}`;
            }
          } else if (feature === 'no_of_liked_data') {
            displayText = isUnlimited 
              ? 'Access wishlist without limitations'
              : `Wishlist access limit: ${value}`;
          } else if (feature === 'matching_enquiry') {
            const inquiryText = userType === 'landlord' ? 'Tenant' : 'Buyer';
            displayText = isUnlimited 
              ? `View unlimited ${inquiryText.toLowerCase()} inquiries`
              : `${inquiryText} inquiries access limit: ${value}`;
          }

          return (
            <li key={feature} style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon 
                sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} 
              />
              <span>{displayText}</span>
            </li>
          );
        })}
        
        {['buyer', 'tenant'].includes(userType) ? (
          <>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} />
              <span>You can wishlist any properties</span>
            </li>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} />
              <span>Communicate via chat with property owners</span>
            </li>
          </>
        ) : (
          <>
            <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'flex-start' }}>
              <CheckCircleOutlineIcon sx={{ color: '#4caf50', fontSize: '1rem', mr: 1, mt: '2px' }} />
              <span>Property boost feature</span>
            </li>
          </>
        )}
      </ul>

      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Button
          variant="contained"
          size="small"
          sx={{
            background: isAddon 
              ? 'linear-gradient(90deg, #ff9800 0%, #ffb74d 100%)' 
              : 'linear-gradient(90deg, #1976d2 0%, #4dabf5 100%)',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: { xs: '0.8rem', sm: '0.85rem' },
            padding: { xs: '6px 12px', sm: '8px 16px' },
            boxShadow: isAddon 
              ? '0 2px 8px rgba(255, 152, 0, 0.3)' 
              : '0 2px 8px rgba(25, 118, 210, 0.3)',
            '&:hover': {
              background: isAddon 
                ? 'linear-gradient(90deg, #f57c00 0%, #ffa726 100%)' 
                : 'linear-gradient(90deg, #1565c0 0%, #42a5f5 100%)',
              boxShadow: isAddon 
                ? '0 4px 12px rgba(255, 152, 0, 0.4)' 
                : '0 4px 12px rgba(25, 118, 210, 0.4)'
            }
          }}
        >
          {isAddon ? 'Select Addon' : 'Select Plan'}
        </Button>
      </Box>
      {/* ✅ Legal links on each paid iOS plan card */}
{isIOSApp && !isFreePlan && (
  <Box sx={{ mt: 1.5, pt: 1.5, borderTop: '1px solid rgba(0,0,0,0.06)', textAlign: 'center' }}>
    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5 }}>
      <Typography
        component="a"
        href="https://propertypincoder.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: '#1976d2', fontSize: '0.68rem', textDecoration: 'underline' }}
      >
        Privacy Policy
      </Typography>
      <Typography sx={{ color: 'text.secondary', fontSize: '0.68rem' }}>•</Typography>
      <Typography
        component="a"
        href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ color: '#1976d2', fontSize: '0.68rem', textDecoration: 'underline' }}
      >
        Terms of Use
      </Typography>
    </Box>
  </Box>
)}
    </Card>
  );
};

const SubscriptionForm = ({ 
  selectedUserType, 
  setSelectedUserType, 
  selectedPlan, 
  setSelectedPlan,
  selectedAddon,
  setSelectedAddon,
  plans, 
  handlePaymentSubmit,
  subscriptions = [],
  iosPlans = [],       // ✅ NEW
  userId, 
}) => {

  const [activeTab, setActiveTab] = useState(0);
  const [tableVisible, setTableVisible] = useState(true);
  const alertRef = React.useRef(null);
  const [addonPlans, setAddonPlans] = useState([]);
  const [loadingAddons, setLoadingAddons] = useState(false);
  const paymentRef = React.useRef(null);
  const [clickedPlan, setClickedPlan] = useState(null);
  const [autoPayEnabled, setAutoPayEnabled] = useState(false);
  const [showGuestModal, setShowGuestModal] = useState(false);

  const isIOSApp = !!window.ReactNativeWebView;

 // ✅ FIXED — reads apple_product_id from your Django plan object
const handleIOSPurchase = (e) => {
  e.preventDefault();
  if (!selectedPlan) { alert("Please select a plan"); return; }

  const productId = selectedPlan.apple_product_id;  // comes from API now

  if (!productId) {
    alert("This plan is not available for iOS purchase yet");
    return;
  }

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: "BUY_SUBSCRIPTION",
      productId: productId,
      user_id: userId,
      plan_name: selectedPlan.plan_name,
      user_type: selectedPlan.user_type,
      plan_id: selectedPlan.plan_id,      // ← add this for Django verify
    })
  );
};

  const { isGuest } = useContext(AuthContext);
const hasPaidPlans = plans.some(
  p => p.plan_name !== 'Free'
);

// const hasPaidPlans = plans.some(p => p.plan_name !== 'Free');
const allPlansAreFree = !hasPaidPlans;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isGuest) {
      setShowGuestModal(true);
      return;
    }
    handlePaymentSubmit(e, autoPayEnabled);
  };

  const hasActiveMainPlan = subscriptions.some(
    sub => sub.user_type === userTypeMappings[selectedUserType]?.label && sub.status === true
  );

  const hasExistingSubscription = activeTab === 0 && clickedPlan 
    ? subscriptions.some(
        sub => sub.user_type === clickedPlan.user_type && 
               sub.status === true && 
               (clickedPlan.plan_name === "Free" || sub.plan_name !== "Free")
      )
    : false;

  useEffect(() => {
    if (hasExistingSubscription && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [hasExistingSubscription]);

  const showPaymentSection = (
    (selectedAddon && !loadingAddons) || 
    (selectedPlan && activeTab === 0 && !hasExistingSubscription)
  );

  const filteredAddonPlans = hasActiveMainPlan ? addonPlans : [];

  const handleUserTypeChange = (userType) => {
    setSelectedUserType(userType);
    setSelectedPlan(null);
    setSelectedAddon(null);
    setActiveTab(0);
    setTableVisible(false);
  };

  const handlePlanSelect = (plan) => {
  if (activeTab === 0) {
    setClickedPlan(plan);
    const hasConflict = subscriptions.some(
      sub => sub.user_type === plan.user_type && 
             sub.status === true && 
             (plan.plan_name === "Free" || sub.plan_name !== "Free")
    );
    if (hasConflict) {
      setSelectedPlan(null);
      setSelectedAddon(null);
    } else {
      setSelectedPlan(plan);
      setSelectedAddon(null); // ✅ clear addon when selecting main plan
    }
  } else {
    setSelectedAddon(plan);
    setSelectedPlan(null); // ✅ ADD THIS — clear main plan when selecting addon
    setClickedPlan(null);  // ✅ ADD THIS — clear clicked plan too
  }

  setTimeout(() => {
    paymentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }, 100);
};

  // ✅ Get plans sorted by PLAN_ORDER
  const getFilteredPlans = () => {
  if (!selectedUserType) return [];

  const userTypeLabel = userTypeMappings[selectedUserType].label;

  const hasPaidPlans = plans.some(p => p.plan_name !== 'Free');

  return plans
    .filter(plan => 
      plan.user_type === userTypeLabel &&
      plan.status === true &&
      (
        hasPaidPlans 
          ? plan.plan_name !== 'Free'   // ✅ hide free if paid exists
          : true                       // ✅ show free if no paid plans
      )
    )
    .map(plan => ({
      ...plan,
      displayName: `${plan.plan_name} ${userTypeLabel} Plan`
    }))
    .sort((a, b) => {
      const indexA = PLAN_ORDER.indexOf(a.plan_name);
      const indexB = PLAN_ORDER.indexOf(b.plan_name);
      return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
    });
};

  useEffect(() => {
    if (!selectedUserType) return;
    const fetchAddonPlans = async () => {
      setLoadingAddons(true);
      try {
        const response = await fetch(`${BASE_URL}/add-on/`);
        const data = await response.json();
        const userTypeLabel = userTypeMappings[selectedUserType].label;
        const filteredAddons = data.filter(addon => 
          addon.user_type === userTypeLabel && addon.status === true
        );
        setAddonPlans(filteredAddons);
      } catch (error) {
        console.error('Error fetching addon plans:', error);
        setAddonPlans([]);
      } finally {
        setLoadingAddons(false);
      }
    };
    fetchAddonPlans();
  }, [selectedUserType]);

  
  const totalWithoutGST = selectedAddon ? selectedAddon.charges : selectedPlan?.charges;
  const isSelectedFreePlan = selectedPlan?.plan_name === 'Free';
  const gst = totalWithoutGST ? Math.round(totalWithoutGST * 0.18) : 0;
  // const base = totalWithoutGST ? Math.round(totalWithoutGST / 1.18) : 0;
  // const gst = totalWithoutGST ? (totalWithoutGST - base).toFixed(2) : '0.00';

  return (
    <Container sx={{ py: 4, flex: 1, display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 'sm' }}>
      <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', mt: 0 }}>Choose Your Subscription</Typography>

    <Card sx={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', p: 2 }}>
  <Typography variant="h6" gutterBottom>I am a:</Typography>

  {/* Free-only notice */}
  {allPlansAreFree && (
   <Card
  sx={{
    mb: 2,
    p: { xs: 2, sm: 3 },
    borderRadius: "16px",
    textAlign: "center",
    background: "linear-gradient(135deg, #e3f2fd 0%, #f5faff 100%)",
    border: "1px solid #90caf9",
    boxShadow: "0 6px 20px rgba(25, 118, 210, 0.15)",
  }}
>
  {/* Emoji / Icon */}
  <Typography
    sx={{
      fontSize: { xs: "2rem", sm: "2.5rem" },
      mb: 1,
    }}
  >
    🎉
  </Typography>

  {/* Title */}
  <Typography
    sx={{
      fontWeight: 700,
      fontSize: { xs: "1.1rem", sm: "1.3rem" },
      color: "#1565c0",
      mb: 1,
    }}
  >
    All Plans Are FREE
  </Typography>

  {/* Description */}
  <Typography
    sx={{
      fontSize: { xs: "0.9rem", sm: "1rem" },
      color: "#555",
      lineHeight: 1.6,
      px: { xs: 1, sm: 2 },
    }}
  >
    Enjoy full access at no cost for now.  
    Paid plans with premium features will be available soon 🚀
  </Typography>

</Card>
  )}

  {/* Only show user type checkboxes if paid plans exist */}
  {!allPlansAreFree && (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
  {Object.keys(userTypeMappings)
    .filter((userType) => {
      const label = userTypeMappings[userType].label;

      return plans.some(
        (plan) =>
          plan.user_type === label &&
          plan.status === true &&
          (
            plans.some(p => p.plan_name !== 'Free')
              ? plan.plan_name !== 'Free'
              : true
          )
      );
    })
    .map((userType) => (
      <FormControlLabel
        key={userType}
        control={
          <MuiCheckbox
            checked={selectedUserType === userType}
            onChange={() => handleUserTypeChange(userType)}
            color="primary"
            size="small"
          />
        }
        label={
          <Typography variant="body2">
            {userTypeMappings[userType].label}
          </Typography>
        }
        sx={{ margin: 0 }}
      />
    ))}
</Box>
  )}
</Card>

      {/* Table image */}
     {tableVisible && !selectedUserType && !allPlansAreFree && (
  <Box sx={{ width: "100%" }}>
    <Box sx={{ width: '100%', position: 'relative', overflow: 'hidden', borderRadius: '5px' }}>
      <Box
        component="img"
        src={subformtable}
        alt="User Types & Access Rights Table"
        sx={{ width: '100%', height: 'auto', objectFit: 'cover', display: 'block', maxWidth: '100%' }}
      />
    </Box>
  </Box>
)}

      {/* Plan Selection */}
      {selectedUserType && (
        <Card sx={{ borderRadius: '16px', boxShadow: '0 4px 30px rgba(0,0,0,0.08)', p: 2, border: '1px solid rgba(255, 255, 255, 0.2)' }}>
          <Typography variant="h6" gutterBottom sx={{ textAlign: 'center', fontWeight: '600', color: '#2a3f5f', fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
            Available {userTypeMappings[selectedUserType].label} Plans:
          </Typography>

          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => { setActiveTab(newValue); setClickedPlan(null); }}
            sx={{ mb: 2 }}
            centered
          >
            <Tab label="Main Plans" />
            <Tab label="Addon Plans" />
          </Tabs>

          <Box sx={{ pt: 1 }}>
            {activeTab === 0 ? (
              <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
                {getFilteredPlans().map((plan) => (
                  <Grid item xs={12} sm={6} md={4} key={plan.plan_id}>
                    <PlanCard 
                      plan={plan} 
                      isSelected={selectedPlan?.plan_id === plan.plan_id}
                      onSelect={() => handlePlanSelect(plan)}
                      userType={selectedUserType}
                       iosPlans={iosPlans}      // ✅ ADD
                       selectedPlan={selectedPlan} // ✅ ADD
                       isIOSApp={isIOSApp}      // ✅ ADD
                    />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
                {loadingAddons ? (
                  <Typography>Loading addon plans...</Typography>
                ) : !hasActiveMainPlan ? (
                  <Alert severity="info" sx={{ width: '100%', my: 2 }}>
                    You need an active {userTypeMappings[selectedUserType]?.label} plan to purchase addons
                  </Alert>
                ) : filteredAddonPlans.length > 0 ? (
                  filteredAddonPlans.map((plan) => (
                    <Grid item xs={12} sm={6} md={4} key={plan.addOn_id}>
                      <PlanCard 
                        plan={plan} 
                        isSelected={selectedAddon?.addOn_id === plan.addOn_id}
                        onSelect={() => handlePlanSelect(plan)}
                        userType={selectedUserType}
                        isAddon
                        iosPlans={iosPlans}      // ✅ ADD
  selectedPlan={selectedPlan} // ✅ ADD
  isIOSApp={isIOSApp} 
                      />
                    </Grid>
                  ))
                ) : (
                  <Typography>No addon plans available for this user type</Typography>
                )}
              </Grid>
            )}
          </Box>
        </Card>
      )}

      {/* Existing subscription warning */}
      {activeTab === 0 && hasExistingSubscription && (
        <Alert severity="warning" sx={{ mt: 2, mb: 2 }} ref={alertRef}>
          You already have an Active {clickedPlan?.user_type} Subscription.
          To get More Features you can Purchase AddOn Plans.
        </Alert>
      )}

      {/* Payment Section */}
      {showPaymentSection && (
        <Card ref={paymentRef} sx={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', p: 2, mb: 3 }}>
          <Typography variant="h5" gutterBottom sx={{ fontSize: '1.3rem' }}>
            Payment Details
          </Typography>
          <Divider sx={{ mb: 2 }} />

         <Box
  component="form"
  onSubmit={isIOSApp ? (e) => e.preventDefault() : handleFormSubmit}
>
            <Typography variant="h6" gutterBottom>
              Selected {selectedAddon ? 'Addon' : 'Plan'}:
            </Typography>

           {/* Payment Section Table — replace the existing TableBody content */}
<Table size="small">
  <TableBody>
    <TableRow>
      <TableCell sx={{ padding: '6px' }}>Type</TableCell>
      <TableCell sx={{ padding: '8px' }}>
        {selectedAddon ? 'Addon Plan' : selectedPlan?.plan_name}
      </TableCell>
    </TableRow>
    <TableRow>
      <TableCell sx={{ padding: '8px' }}>User Type</TableCell>
      <TableCell sx={{ padding: '8px' }}>
        {selectedAddon ? selectedAddon.user_type : selectedPlan?.user_type}
      </TableCell>
    </TableRow>

    {isSelectedFreePlan ? (
      <TableRow>
        <TableCell sx={{ padding: '8px', borderTop: '1px solid #e0e0e0' }}>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>Amount Payable</Typography>
        </TableCell>
        <TableCell sx={{ padding: '8px', borderTop: '1px solid #e0e0e0', textAlign: 'right' }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: '#4caf50' }}>FREE</Typography>
        </TableCell>
      </TableRow>

    ) : isIOSApp ? (
      // ✅ iOS — show Apple's price only, no GST breakdown
      (() => {
        const appleMatch = iosPlans.find(
          p => p.productId === selectedPlan?.apple_product_id
        );
        const applePrice = appleMatch?.price ?? null;

        return (
          <>
            <TableRow>
              <TableCell sx={{ padding: '8px', color: 'text.secondary' }}>
                Billed via App Store
              </TableCell>
              <TableCell sx={{ padding: '8px', textAlign: 'right', color: 'text.secondary' }}>
                Incl. all taxes & fees
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ padding: '8px', borderTop: '1px solid #e0e0e0' }}>
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  Amount Payable
                </Typography>
              </TableCell>
              <TableCell sx={{ padding: '8px', borderTop: '1px solid #e0e0e0', textAlign: 'right' }}>
                <Typography variant="body2" sx={{ fontWeight: 700, color: '#1976d2' }}>
                  {applePrice ?? `₹${selectedPlan?.charges}`}
                </Typography>
              </TableCell>
            </TableRow>
          </>
        );
      })()

    ) : (
      // ✅ Android/Web — existing GST breakdown
      <>
        <TableRow>
          <TableCell sx={{ padding: '8px', color: 'text.secondary' }}>Total Amount</TableCell>
          <TableCell sx={{ padding: '8px', textAlign: 'right' }}>
            ₹{selectedAddon ? selectedAddon.charges : selectedPlan?.charges}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ padding: '8px', color: 'text.secondary' }}>GST (18%)</TableCell>
          <TableCell sx={{ padding: '8px', textAlign: 'right', color: 'text.secondary' }}>
            ₹{gst}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={{ padding: '8px', borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>Amount Payable</Typography>
          </TableCell>
          <TableCell sx={{ padding: '8px', borderTop: '1px solid #e0e0e0', textAlign: 'right' }}>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              ₹{totalWithoutGST + gst}
            </Typography>
          </TableCell>
        </TableRow>
      </>
    )}
  </TableBody>
</Table>

           {/* ✅ Bottom bar */}
<Box sx={{ mt: 2, p: 1.5, backgroundColor: '#f5f5f5', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <Box>
    <Typography variant="body1" sx={{ fontWeight: 700, color: isSelectedFreePlan ? '#4caf50' : 'inherit' }}>
      {isSelectedFreePlan
        ? 'FREE'
        : isIOSApp
        ? (() => {
            const appleMatch = iosPlans.find(p => p.productId === selectedPlan?.apple_product_id);
            return appleMatch?.price ?? `₹${totalWithoutGST}`;
          })()
        : `₹${totalWithoutGST + gst}`
      }
    </Typography>
    <Typography variant="caption" sx={{ color: '#1976d2' }}>
      {isIOSApp && !isSelectedFreePlan ? 'App Store price' : 'Amount Payable'}
    </Typography>
  </Box>

  {/* button stays same */}

               {/* ✅ CONDITIONAL BUTTON — iOS vs Web/Android */}
  {isIOSApp ? (
    // ✅ iOS: trigger RevenueCat In-App Purchase
    <Button
      variant="contained"
      onClick={handleIOSPurchase}
      disabled={!selectedPlan || isSelectedFreePlan}
      sx={{
        borderRadius: "8px",
        py: 1,
        px: 3,
        fontWeight: 600,
        background: "linear-gradient(90deg, #1976d2 0%, #4dabf5 100%)",
      }}
    >
      Subscribe on iOS
    </Button>
  ) : (
    // ✅ Web/Android: existing Razorpay flow
    <Button
      type="submit"
      variant="contained"
      sx={{
        borderRadius: "8px",
        py: 1,
        px: 3,
        fontWeight: 600,
        background: "linear-gradient(90deg, #1976d2 0%, #4dabf5 100%)",
      }}
    >
      {isSelectedFreePlan ? "Activate Free Plan" : "Complete Payment"}
    </Button>
  )}
            </Box>
          </Box>
        </Card>
      )}

      {/* ✅ Apple required — legal links always visible on subscription page */}
{isIOSApp && (
  <Box sx={{ 
    px: 2, 
    pb: 2, 
    textAlign: 'center',
    borderTop: '1px solid rgba(0,0,0,0.08)',
    pt: 2
  }}>
    <Typography variant="caption" sx={{ 
      color: 'text.secondary', 
      fontSize: '0.72rem',
      lineHeight: 1.8,
      display: 'block',
      mb: 1
    }}>
      Subscriptions automatically renew unless cancelled at least 24 hours 
      before the end of the current period. You can manage or cancel your 
      subscription in your Apple ID Account Settings at any time.
    </Typography>

    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1.5 }}>
      <Typography
        component="a"
        href="https://propertypincoder.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ 
          color: '#1976d2', 
          fontSize: '0.75rem', 
          textDecoration: 'underline',
          cursor: 'pointer'
        }}
      >
        Privacy Policy
      </Typography>

      <Typography sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>•</Typography>

      <Typography
        component="a"
        href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ 
          color: '#1976d2', 
          fontSize: '0.75rem', 
          textDecoration: 'underline',
          cursor: 'pointer'
        }}
      >
        Terms of Use (EULA)
      </Typography>
    </Box>
  </Box>
)}

      <GuestLoginModal open={showGuestModal} onClose={() => setShowGuestModal(false)} />
    </Container>
  );
};

export default SubscriptionForm;